import { createFolderReqSchema } from '@ospace/schemas/file-manager'
import { ErrorMessage, Field, Form, Formik } from 'formik'

import { Modal } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useCreateFolderMutation } from '../hooks'
import { Button } from './ui'

export type CreateFolderFormModalButtonProps = {
  campaignId: number
  folderPath: string
  disabled?: boolean
}

export const CreateFolderFormModalButton = (props: CreateFolderFormModalButtonProps) => {
  const mutation = useCreateFolderMutation({
    campaignId: props.campaignId,
  })
  const [opened, { open, close }] = useDisclosure(false)
  return (
    <>
      <Button
        onClick={open}
        size='sm'
        variant='secondary'
        disabled={props.disabled}
        submitting={mutation.isLoading}
      >
        Create Folder
      </Button>

      <Modal opened={opened} onClose={close} withCloseButton={false} centered padding='lg'>
        <Formik
          validationSchema={createFolderReqSchema}
          initialValues={{
            campaignId: props.campaignId,
            baseFolderPath: props.folderPath,
            folderName: '',
          }}
          onSubmit={async (req, actions) => {
            close()
            actions.resetForm()
            await mutation.mutateAsync(req)
          }}
        >
          <Form className='form' noValidate id='kt_modal_create_folder_form'>
            <div className='w-100'>
              <div className='fv-row mb-10'>
                <label
                  className='d-flex align-items-center fs-5 fw-bold mb-2'
                  htmlFor='file-manager-create-folder-folder-name'
                >
                  <span className='required'>Folder</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Specify your new folder name'
                  ></i>
                </label>
                <Field
                  id='file-manager-create-folder-folder-name'
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  name='folderName'
                  placeholder=''
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='folderName' />
                </div>
              </div>
            </div>

            <div className='d-flex justify-content-end gap-2 mt-10'>
              <Button size='sm' variant='secondary' onClick={close}>
                Cancel
              </Button>
              <Button type='submit' size='sm' variant='primary' disabled={mutation.isLoading}>
                Create
              </Button>
            </div>
          </Form>
        </Formik>
      </Modal>
    </>
  )
}
